export default __webpack_public_path__ + "static/media/SEC1560.34I-39024_-22964_0.68e8d087.jpg";